export default __webpack_public_path__ + "static/media/register.0a5ebcf4.svg";